// Blotting Paper
import Blotting_Paper from './img/Blotting_Paper.svg'

// Biohazardous_Waste.svg
import Biohazardous from './img/Biohazardous_Waste.svg'

// CellSpreader
import CellSpreader from './img/cell-spreader.svg'

// ChromatographyColumn
import ChromatographyColumn from './img/column-blue-full-closed.svg'

// Petridish
import petridishLB from "./img/petri-dish-lb.svg";
import petridishLBAMP from "./img/petri-dish-lb-amp.svg";
import petridishLBAMPARA from "./img/petri-dish-lb-amp-ara.svg";

// Pipette
import P2_Pipette from './img/Micropipette/P2_Micropipette.svg'
import P20_Pipette from './img/Micropipette/P20_Micropipette.svg'
import P200_Pipette from './img/Micropipette/P200_Micropipette.svg'
import P1000_Pipette from './img/Micropipette/P1000_Micropipette.svg'

// Tip Box
import P2_Tip_Box from './img/TipBox/P2_Tip_Box.svg'
import P20_Tip_Box from './img/TipBox/P20_Tip_Box.svg'
import P200_Tip_Box from './img/TipBox/P200_Tip_Box.svg'
import P1000_Tip_Box from './img/TipBox/P1000_Tip_Box.svg'

// Solution
import SolutionFalconBB from './img/Solution/falcon-bb.svg'
import SolutionFalconCEB from './img/Solution/falcon-ceb.svg'
import SolutionFalconEB from './img/Solution/falcon-eb.svg'
import SolutionFalconWB from './img/Solution/falcon-wb.svg'

// Flask
import OneX_Sodium_Borate_Buffer from './img/flaskFull.svg'

// Freezer
import freezer_closed from './img/freezer-closed.svg'

// Floating Tube Rack
import floatingTubeRack from "./img/floating-solution-tube-rack-empty.svg";

// Gel
import Agarose_Gel from './img/Agarose_Gel.svg'

// Gel Box
import Gel_Electrophoresis_Box from './img/Electrophoresis_Box.svg'

// Ice Bucket
import IceBucket from './img/Ice_Bucket.svg'

// Incubator
import Incubator from './img/incubator.svg'

// Lab Tape
import LabTape from './img/lab-tape.svg'

// Microcentrifuge
import Microcentrifuge from './img/Microcentrifuge.svg'

// Power Suply
import Power_Supply from './img/Power_Supply.svg'

// Power Suply Leads
import Power_Supply_Leads from './img/Power_Supply_Leads.svg'

// Trash
import Trash from './img/Trash.svg'

// Timer
import Timer from './img/timer.svg'

// Vortex
import Vortex from './img/vortex.svg'

// Water Bath
import WaterBath from "./img/Water Bath.svg";

// Waste Collection Jar
import WasteCollectionJar from "./img/waste_collection_jar.svg"


export default {
  Blotting_Paper, Biohazardous, CellSpreader, ChromatographyColumn,
  P2_Pipette, P20_Pipette, P200_Pipette, P1000_Pipette,
  P2_Tip_Box, P20_Tip_Box, P200_Tip_Box, P1000_Tip_Box,
  SolutionFalconBB, SolutionFalconCEB, SolutionFalconEB, SolutionFalconWB,
  petridishLB, petridishLBAMP, petridishLBAMPARA, OneX_Sodium_Borate_Buffer,
  freezer_closed, floatingTubeRack, Agarose_Gel, Gel_Electrophoresis_Box,
  IceBucket, LabTape, Microcentrifuge, Power_Supply, Power_Supply_Leads,
  Trash, Timer, Vortex, WaterBath, Incubator, WasteCollectionJar
}